import qs from 'qs'

function urlWithParams(url, params) {
  return `${url}?${qs.stringify(params)}`
}

export default { urlWithParams }
